document.addEventListener('DOMContentLoaded', () => {
    const urlPathname = window.location.pathname.split('/pages/')[1];
    const orders = JSON.parse(localStorage.getItem(`orders-${urlPathname}`));
    if (orders) {
        renderOrderList();
        // renderTotalQuantity();
    }
});
function handleOrderVisibility() {
    const urlPathname = window.location.pathname.split('/pages/')[1];
    const orders = JSON.parse(localStorage.getItem(`orders-${urlPathname}`));
    const orderList = document.querySelector('.mix-match-order__order-list');
    const orderContainer = document.getElementById('buildYourPack--order');

    if (orders && orders.length > 0) {
        orderContainer.classList.remove('hidden');
    } else {
        orderContainer.classList.add('hidden');
    }
}

function renderOrderList() {
    const urlPathname = window.location.pathname.split('/pages/')[1];
    const ordersKey = `orders-${urlPathname}`;
    const orders = JSON.parse(localStorage.getItem(ordersKey)) || [];
    const orderListContainer = document.querySelector('.mix-match-order__order-list__list');
    const orderContainer = document.getElementById('buildYourPack--order');
    const productListContainer = document.querySelector('.mix-match-order__order-list__add-to-cart-list');
    const itemsTotalElement = document.querySelector('.items-total'); // Selecciona el elemento para mostrar el total

    orderListContainer.innerHTML = '';
    productListContainer.innerHTML = '';

    const productCards = document.querySelectorAll('.mix-match__collection-product__product-card');
    productCards.forEach(card => {
        const variantId = card.getAttribute('data-variant-id');
        const removeToOrderButton = card.querySelector('.remove-to-order');
        const isInOrder = orders.some(order => order.id === variantId);

        if (removeToOrderButton) removeToOrderButton.classList.toggle('hidden', !isInOrder);
    });

    if (orders.length > 0) {
        orderContainer.classList.remove('hidden');
    } else {
        orderContainer.classList.add('hidden');
    }

    // Variable para acumular el precio total
    let totalPrice = 0;

    orders.forEach((product) => {
        const productElement = document.createElement('div');
        productElement.classList.add('mix-match-order__order-list__product');

        const productInfoContainer = document.createElement('div');
        productInfoContainer.classList.add('product-info-container');

        const productInfoQuantity = document.createElement('div');
        productInfoQuantity.classList.add('product-info-quantity');
        productInfoQuantity.textContent = `x${product.quantity}`;

        const productTitleContainer = document.createElement('div');
        const productTitleElement = document.createElement('span');
        productTitleElement.textContent = product.title;
        productTitleElement.classList.add('product-title');
        const productQuantity = document.createElement('span');
        productQuantity.textContent = product.quantity + 'x';
        productQuantity.classList.add('product-quantity');

        const productPrice = document.createElement('div');
        productPrice.textContent = product.price;
        productPrice.classList.add('product-price');

        const productRemove = document.createElement('span');
        productRemove.textContent = window.bundlesStrings.remove;
        productRemove.classList.add('product-remove');

        productRemove.addEventListener('click', () => {
            const indexToRemove = orders.findIndex(item => item.id === product.id);

            if (indexToRemove !== -1) {
                orders.splice(indexToRemove, 1);
                localStorage.setItem(ordersKey, JSON.stringify(orders));
                renderOrderList();
                updateBundleAddToCartButton();
            }
        });

        productTitleContainer.appendChild(productQuantity);
        productTitleContainer.appendChild(productTitleElement);
        productTitleContainer.appendChild(productRemove);

        const productContainer = document.createElement('div');
        productContainer.classList.add('product');
        productContainer.appendChild(productTitleContainer);
        productContainer.appendChild(productPrice);

        productListContainer.appendChild(productContainer);

        const productImageElement = document.createElement('img');
        productImageElement.src = product.image;
        productImageElement.alt = product.title;
        productImageElement.title = product.title;
        productImageElement.classList.add('product-image');

        productInfoContainer.appendChild(productImageElement);
        
        productElement.appendChild(productInfoContainer);
        productElement.appendChild(productInfoQuantity);

        orderListContainer.appendChild(productElement);

        const cleanedPrice = parseFloat(product.price.replace('€', '').replace(',', ',').trim());

        // Calcular el precio total
        totalPrice += cleanedPrice * product.quantity;
    });

    itemsTotalElement.textContent = `${totalPrice.toFixed(2)}€`;

    handleOrderVisibility();
}



function addToOrder(event) {
    const card = event.target.closest('.mix-match__collection-product__product-card');
    const image = card.getAttribute('data-product-image');
    const type = card.getAttribute('data-product-type');
    const variantId = card.getAttribute('data-variant-id');
    const productTitle = card.getAttribute('data-product-title');
    const productVariantTitle = card.getAttribute('data-variant-title');
    const price = card.getAttribute('data-price');
    const priceWithoutCurrency = card.getAttribute('data-price-without-currency');

    const productInfo = {
        id: variantId,
        image,
        type,
        title: productTitle,
        variantTitle: productVariantTitle,
        price,
        priceWithoutCurrency,
        quantity: 1,
    };

    const urlPathname = window.location.pathname.split('/pages/')[1];
    let orders = JSON.parse(localStorage.getItem(`orders-${urlPathname}`)) || [];

    // Verificar si el producto ya está en el carrito
    const existingProductIndex = orders.findIndex(order => order.id === productInfo.id);

    if (existingProductIndex > -1) {
        // El producto ya existe, actualizar la cantidad
        orders[existingProductIndex].quantity += 1;
    } else {
        // El producto no existe, añadirlo al carrito
        orders.push(productInfo);
    }

    // Guardar la lista actualizada en el localStorage
    localStorage.setItem(`orders-${urlPathname}`, JSON.stringify(orders));
    
    // Actualizar la vista y el botón del carrito
    renderOrderList();
    updateBundleAddToCartButton();
}




function removeToOrder(event) {
    const card = event.target.closest('.mix-match__collection-product__product-card');
    const variantId = card.getAttribute('data-variant-id');
    const urlPathname = window.location.pathname.split('/pages/')[1];

    let orders = JSON.parse(localStorage.getItem(`orders-${urlPathname}`)) || [];
    const productIndex = orders.findIndex(item => item.id === variantId);

    if (productIndex !== -1) {
        if (orders[productIndex].quantity > 1) {
            orders[productIndex].quantity -= 1;
        } else {
            orders.splice(productIndex, 1);
        }
        localStorage.setItem(`orders-${urlPathname}`, JSON.stringify(orders));
        
        renderOrderList();
        updateBundleAddToCartButton();
        
        if (!orders.some(item => item.id === variantId)) {
            event.target.classList.add('hidden');
            if (event.target.previousElementSibling.classList.contains('hidden')) {
                event.target.previousElementSibling.classList.remove('hidden');
            }
        }
    }
}




// Función que se ejecuta para añadir los productos al carrito
function addOrderToCart() {
    const urlPathname = window.location.pathname.split('/pages/')[1];
    const products = JSON.parse(localStorage.getItem(`orders-${urlPathname}`));

    if (!products || products.length === 0) {
        console.error('No hay productos en el carrito.');
        return;
    }

    try {
        const reversedProducts = products.reverse();

        const items = reversedProducts.map((product) => {
            const { id, quantity } = product;
            return { id, quantity };
        });

        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        const formData = {
            items,
            sections: cart.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname,
        };

        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Error al agregar producto al carrito');
                }
                return response.json();
            })
            .then((data) => {
                fetch(`${routes.cart_url}?section_id=cart-drawer`)
                    .then((response) => response.text())
                    .then((responseText) => {
                        const html = new DOMParser().parseFromString(responseText, 'text/html');
                        const sourceQty = html.querySelector('.drawer__inner');
                        document.querySelector('cart-drawer').classList.remove('is-empty');
                        document.querySelector('.drawer__inner').innerHTML = sourceQty.innerHTML;
                        if (localStorage.getItem('__ui')) localStorage.removeItem('__ui');

                        // const cartBubble = document.querySelector('.cart-count-bubble');
                        // cartBubble?.classList.remove('hidden');
                        // const totalQuantity = data.items.reduce((total, item) => {
                        //     return total + item.quantity;
                        // }, 0);
                        // cartBubble.querySelector('span[aria-hidden="true"]').innerText = totalQuantity;
                        cart.open();
                        localStorage.removeItem(`orders-${urlPathname}`);
                        renderOrderList();
                    })
                    .catch((e) => {
                        console.error(e);
                    });
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    } catch (error) {
        console.error('Error:', error);
    }
}

// Función para actualizar el botón según el estado del carrito
function updateBundleAddToCartButton() {
    const urlPathname = window.location.pathname.split('/pages/')[1];
    const orders = JSON.parse(localStorage.getItem(`orders-${urlPathname}`)) || [];
    const bundleAddToCartButton = document.getElementById('bundle-add-to-cart');

    bundleAddToCartButton.textContent = window.bundlesStrings.add_to_cart;
    bundleAddToCartButton.onclick = addOrderToCart;
}

// Llamar a la función para actualizar el botón cuando se cargue la página
document.addEventListener('DOMContentLoaded', updateBundleAddToCartButton);
